import { useRef } from "react";
import styles from "./animation.module.scss";
const defaultEnterSteps = [
    styles.enter,
    styles["enter-active"],
    styles["enter-done"],
  ],
  defaultExitSteps = [
    styles["exit"],
    styles["exit-active"],
    styles["exit-done"],
  ];
const defaultDuration = 200;

export function useCssTransition(divRef: React.RefObject<HTMLDivElement>) {
  const startClassNameStep = async (steps: string[]) => {
    const previewClassName = divRef.current?.className;
    const setClassName = (className: string) => {
      if (divRef.current) {
        divRef.current.style.transitionDuration = `${defaultDuration}ms`;
        divRef.current.className = `${previewClassName} ${className}`;
      }
    };
    for (let i = 0; i < steps.length; i++) {
      const step = steps[i];
      setClassName(step);
      await new Promise((resolve) => setTimeout(resolve, defaultDuration));
    }
  };
  const enter = async () => {
    return startClassNameStep(defaultEnterSteps);
  };
  const exit = async () => {
    return  startClassNameStep(defaultExitSteps);
  };
  return {
    divRef,
    enter,
    exit,
  };
}
